export default {
  myFiles: 'Moji dokumenti',
  newDocument: 'Novi dokument',
  messages: 'Poruke',
  addresses: 'Adrese',
  newAddress: '+ Nova adresa',
  aboutUs: 'O nama',
  addArticle: 'Dodaj artikal',
  addAttribute: 'Dodaj atribut',
  addBank: 'Dodaj banku',
  addBlog: 'Dodaj novost',
  addBrand: 'Dodaj brand',
  addCategory: 'Dodaj kategoriju',
  addCompany: 'Dodaj kompaniju',
  addCountry: 'Dodaj državu',
  addCurrency: 'Dodaj valutu',
  addCustomerBankAccount: 'Dodaj korisnički račun',
  accountDetails: 'Detalji o profilu',
  addExpressPost: 'Dodaj brzu poštu',
  addInterestsArea: 'Dodaj djelatnost',
  addMeasurementUnit: 'Dodaj jedinicu mjere',
  addPoll: 'Dodaj anketu',
  addProductSale: 'Dodaj akciju',
  addTab: 'Dodaj tab',
  blog: 'Blog',
  addTown: 'Dodaj grad',
  addToCart: 'Dodaj u korpu',
  addToCart2: 'U košaricu',
  docDate: 'Datum dok',
  account: 'Konto',
  owes: 'Duguje',
  comment: 'Komentar',
  accountNumber: 'Broj računa',
  claims: 'Potražuje',
  paymentTerm: 'Rok plaćanja',
  bookingDateShort: 'Datum knj',
  addUser: 'Dodaj korisnika',
  addVariation: 'Dodaj varijaciju',
  apply: 'Primjeni',
  article: 'Proizvod',
  areYouSureArticle: 'Jeste li sigurni da želite izbrisati artikal {article}?',
  areYouSureAttribute: 'Jeste li sigurni da želite izbrisati atribut {attribute}?',
  areYouSureAttributeArticle: 'Jeste li sigurni da želite izbrisati atribut?',
  areYouSureAttributeValue:
    'Jeste li sigurni da želite izbrisati {attributeValue} vrijednost atributa?',
  areYouSureBank: 'Jeste li sigurni da želite izbrisati banku {bank}?',
  areYouSureBlog: 'Jeste li sigurni da želite izbrisati novost {blog}?',
  areYouSureBrand: 'Jeste li sigurni da želite izbrisati brend {brand}?',
  areYouSureCategory: 'Jeste li sigurni da želite izbrisati kategoriju {category}?',
  areYouSureCompany: 'Jeste li sigurni da želite izbrisati kompaniju {company}?',
  areYouSureCountry: 'Jeste li sigurni da želite izbrisati državu {country}?',
  areYouSureCurrency: 'Jeste li sigurni da želite izbrisati valutu {currency}?',
  areYouSureCustomerBankAccount:
    'Jeste li sigurni da želite izbrisati korisnički bankovni račun {bankAccount}?',
  areYouSureExpressPost: 'Jeste li sigurni da želite izbrisati brzu poštu {post}?',
  areYouSureInterestsArea: 'Jeste li sigurni da želite izbrisati djelatnost {area}?',
  areYouSureProductSale: 'Jeste li sigurni da želite izbrisati akciju {productSale}?',
  areYouSureSelected: 'Jeste li sigurni da želite izbrisati odabrane zapise?',
  areYouSureTab: 'Jeste li sigurni da želite izbrisati tab {tab}?',
  areYouSureTown: 'Jeste li sigurni da želite izbrisati grad {town}?',
  areYouSureUser: 'Jeste li sigurni da želite izbrisati korisnika {user}?',
  areYouSureCancelOrder: 'Da li ste sigurni da želite otkazati narudžbu?',
  areYouSureApproveOrder: 'Da li ste sigurni da želite odobriti narudžbu?',
  articleDetails: 'Detalji artikla',
  articleDetailsInfo: 'Unesite detalje artikla',
  articles: 'Artikli',
  attributes: 'Atributi',
  banks: 'Banke',
  blogs: 'Novosti',
  brands: 'Brendovi',
  brand: 'Brend',
  service: 'Servis',
  cancel: 'Otkaži',
  newRequest: 'Novi zahtjev',
  contactPerson: 'Kontakt osoba',
  categories: 'Kategorije',
  category: 'Kategorija',
  serialNumber: 'Serijski broj',
  productCode: 'Šifra proizvoda',
  checkout: 'Naplata',
  download: 'Preuzmi',
  actions: 'Akcije',
  sales: 'Akcije',
  folderIsEmpty: 'Vaša mapa sa dokumentima je prazna',
  physicalPersons: 'Fizička lica',
  goToCheckout: 'Idi na naplatu',
  choose: 'Izaberite',
  chooseOptions: 'Izaberite opcije',
  contact: 'Kontakt',
  onlineShopping: 'Online kupovina',
  ord: 'Rbr',
  myAccount2: 'Moj nalog',
  myArticles: 'Moji proizvodi',
  followUsOnSocialMedia: 'Pratite nas na društvenim mrežama',
  deliveryAndPayment: 'Dostava i plaćanje',
  complaintsAndReturns: 'Reklamacija i povrati',
  securityAndPrivacy: 'Sigurnost i privatnost',
  termsOfService: 'Uvjeti korištenja i kupovine',
  youNeedHelp: 'Trebate pomoć?',
  from: 'Od',
  to: 'Do',
  title: 'Naslov',
  markAllAsRead: 'Označi sve kao pročitano',
  faq: 'Česta pitanja',
  howToRegister: 'Kako se registrirati?',
  shoppingHelp: 'Pomoć pri kupovini',
  bonusProgramRules: 'Pravila Bonus programa',
  comingSoon: 'Uskoro',
  companies: 'Kompanije',
  countries: 'Države',
  countryDetails: 'Detalji države',
  countryDetailsInfo: 'Unesite detalje države',
  viewFinances: 'Pogledaj financije',
  coupons: 'Kuponi',
  currencies: 'Valute',
  customerBankAccounts: 'Korisnički računi',
  profileDashboard: 'Dashboard',
  defaultAddress: 'Sljedeće adrese će se prema zadanim postavkama koristiti na stranici za naplatu.',
  delete: 'Izbriši',
  currentDebt: 'Trenutno zaduženje',
  deleteArticle: 'Izbriši artikal',
  paymentTerms: 'Uvjeti plaćanja',
  deleteAttribute: 'Izbriši atribut',
  debtOutsideCurrency: 'Dug van valute',
  deleteBank: 'Izbriši banku',
  deleteBlog: 'Izbriši novost',
  edit: 'Izmjeni',
  approvedDebt: 'Odobreno zaduženje',
  deleteBrand: 'Izbriši brand',
  deleteCategory: 'Izbriši kategoriju',
  notSetAnyAddressYet: 'Još niste postavili nijednu adresu.',
  deleteCompany: 'Izbriši kompaniju',
  deleteCountry: 'Izbriši državu',
  deleteCurrency: 'Izbriši valutu',
  deleteCustomerBankAccount: 'Izbriši korisnički bankovni račun',
  deleteExpressPost: 'Izbriši brzu poštu',
  deleteInterestsArea: 'Izbriši djelatnost',
  deleteProductSale: 'Izbriši akciju',
  deleteSelected: 'Izbriši odabrano',
  deleteTab: 'Izbriši tab',
  deleteTown: 'Izbriši grad',
  deleteUser: 'Izbriši korisnika',
  deleteVariationImage: 'Jeste li sigurni da želite izbrisati sliku varijacije?',
  details: 'Detalji',
  detailsInfo: 'Unesite detalje',
  editArticle: 'Ažuriraj artikal',
  editAttribute: 'Ažuriraj atribut',
  editBank: 'Ažuriraj banku',
  editBlog: 'Ažuriraj novost',
  editBrand: 'Ažuriraj brand',
  editCategory: 'Ažuriraj kategoriju',
  editCompany: 'Ažuriraj kompaniju',
  editCountry: 'Ažuriraj državu',
  editCurrency: 'Ažuriraj valutu',
  editCustomerBankAccount: 'Ažuriraj korisnički račun',
  editExpressPost: 'Ažuriraj brzu poštu',
  editInterestArea: 'Ažuriraj djelatnost',
  editPoll: 'Ažuriraj anketu',
  editProductSale: 'Ažuriraj akciju',
  editTab: 'Ažuriraj tab',
  editTown: 'Ažuriraj grad',
  editUser: 'Ažuriraj korisnika',
  expressPosts: 'Brze pošte',
  forgotPassword: 'Zaboravljena lozinka',
  greetings: 'Zdravo',
  homePageTitle: 'Početna',
  highlightedCategories: 'Izdvojeno',
  import: 'Importuj',
  importArticles: 'Importuj artikle',
  interestsAreas: 'Djelatnosti',
  cancel2: 'ODUSTANI',
  cancel3: 'Odustani',
  login: 'Prijava',
  logIn: 'Prijavi se',
  logout: 'Odjava',
  measurementUnits: 'Jedinice mjere',
  myAccount: 'Moj profil',
  delete2: 'IZBRIŠI',
  myProfile: 'Profil',
  news: 'Vijesti',
  newArticles: 'Novi proizvodi',
  no: 'Ne',
  attention: 'Pažnja',
  warning: 'Upozorenje',
  areYouSureYouWantToDeleteAcc: 'Da li sigurno želite izbrisati vaš račun? Unesite lozinku da bi ste izbrisali vaš račun.',
  areYouSureYouWantToDeleteAddress: 'Jeste li sigurni da želite ukloniti odabranu adresu?',
  noItemSelected: 'Nema odabranih zapisa',
  noRecords: 'Nema rezultata prema traženim parametrima',
  notFound: 'Trazena stranica nije pronadjena',
  orderArticles: 'Artikli u košarici',
  orders: 'Narudžbe',
  polls: 'Ankete',
  priceRange: 'Cijenovni rang',
  productSales: 'Akcije',
  recentlyViewdItems: 'Ranije ste gledali',
  register: 'Registracija',
  resetFilters: 'Poništi filtere',
  rma: 'Prijavljene nepravilnosti (RMA)',
  rmaForm: 'Reklamacije',
  save: 'Sačuvaj',
  saveArticle: 'Sačuvaj artikal',
  saveCategory: 'Sačuvaj kategoriju',
  saveCountry: 'Sačuvaj državu',
  search: 'Pretraga',
  find: 'Unesite minimalno 3 karaktera...',
  selectAction: 'Izaberite akciju',
  shoppingCart: 'Korpa',
  tabs: 'Tabovi',
  terms: 'Uslovi korištenja',
  townDetails: 'Detalji grada',
  townDetailsInfo: 'Unesite detalje grada',
  towns: 'Gradovi',
  total: 'Ukupno',
  amount: 'Iznos',
  topBrands: 'Top Brendovi',
  userProfile: 'Korisnički profil',
  users: 'Korisnici',
  userArticles: 'Proizvodi odabrani za vas',
  viewAll: 'Vidi sve',
  viewAllFrom: 'Vidi sve iz',
  addToCartSuccessMessage: 'Upravo ste dodali artikl u <br/> košaricu: ',
  continueShopping: 'Nastavi kupnju',
  clearShoppingCart: 'Isprazni košaricu',
  updateShoppingCart: 'Ažuriraj košaricu',
  goToShoppingCart: 'Idi u košaricu',
  wishlist: 'Lista želja',
  addToWishlist: 'Dodaj u listu želja',
  yes: 'Da',
  reviews: 'Recenzija',
  tabReviews: 'Recenzije',
  writeReview: 'Unesite Vašu recenziju',
  submitReview: 'Pošalji recenziju',
  anonymous: 'Anonimno',
  linkedArticles: 'Povezani proizvodi',
  quickPreview: 'Brzi pregled',
  loginRegisterTitle: 'Prijava / Kreiranje računa',
  loginTitle: 'Prijava',
  loginSubTitle: 'Ukoliko imate korisnički račun prijavite se.',
  loginButton: 'PRIJAVA',
  registerTitle: 'Zatražite korisnički račun',
  registerSubTitle: 'Popunite tražene informacije i naš tim će vas kontaktirati u najkraćem roku,te ćemo vam izraditi korisnički račun. Hvala!',
  chooseCountry: 'Izaberite državu',
  chooseTown: 'Izaberite grad',
  registerSectionLoginDataTitle: 'Podaci za prijavu',
  acceptTerms: 'Prihvatam uvjete korištenja',
  registerSubmit: 'Zatraži račun',
  repeatOrder: 'Ponovi narudžbu',
  close: 'Zatvori',
  defaultSort: 'Zadano sortiranje',
  sortByRating: 'Sortiraj po ocjeni',
  sortByDateOldest: 'Sortiraj po datumu objave: starije prema novom',
  sortByDateNewest: 'Sortiraj po datumu objave: novo prema starijem',
  sortByPriceLow: 'Sortiraj po cijeni: niža prema višoj',
  sortByPriceHigh: 'Sortiraj po cijeni: viša prema nižoj',
  pagingResults: 'Prikazuje se {fromResults} - {toResults} od {totalItems} rezultata',
  showMore: 'Prikaži više',
  productIsAvalible: 'Proizvod je dostupan',
  productIsAvalibleToOrder: 'Proizvod je dostupan po narudžbi',
  deliveryTimeDays: 'Vrijeme isporuke je {days} dana od narudžbe proizvoda',
  itemIsAvalibleContactRepresentative: 'Artikal je dostupan po narudžbi. Molimo kontaktirajte Vašeg prodajnog predstavnika.',
  availableOnRequest: 'Dostupno na upit',
  requestPresentation: 'Zatraži prezentaciju',
  howDoYouRateThisProduct: 'Kako ocjenjujete ovaj proizvod?',
  administrator: 'Administrator',
  passwordRecovery: 'Oporavak lozinke',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Unesite Vašu e-mail adresu ispod i poslat ćemo vam upute za resetovanje!',
  reset: 'Resetuj',
  remembered: 'Zapamćeno',
  finances: 'Financije',
  allRightsReserved: 'Sva prava pridržana',
  updateAddress: 'Ažuriraj adresu',
  state: 'Država',
  chooseState: 'Izaberite državu',
  listIsEmpty: 'Lista je prazna',
  noResultsAccordingToTheGivenParameters: 'Nema rezultata prema zadanim parametrima',
  termsOfUseIsMandatory: 'Polje Uvjeti korištenja je obavezno',
  resetPassword: 'Reset lozinke',
  accVerificationInProgress: 'Verifikacija računa u toku',
  accVerification: 'Verifikacija računa',
  verificationLinkHasExpired: 'Verifikacijski link je istekao. Molimo kontaktirajte naše administratore: support@eurosan.ba ili +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'Upravo ste dodali artikl u košaricu:',
  manufacturer: 'Proizvođač',
  productName: 'Naziv proizvoda',
  shoppingCarts: 'Košarice',
  preview: 'Pregled',
  documentName: 'Naziv dokumenta',
  status: 'Status',
  orderNumber: 'Broj narudžbe',
  orderer: 'Naručioc',
  date: 'Datum',
  document: 'Dokument',
  delivery: 'Dostava',
  deliverTo: 'Dostaviti na',
  discount: 'Rabat',
  savingsByUsingPromoCode: 'Ušteda korištenjem promo koda',
  itemAddedToCart: 'Artikal dodan u košaricu.',
  articlesOnSale: 'Artikli na akciji',
  controlPanel: 'Kontrolna ploča',
  tags: 'Tagovi',
  totalAmountWithDelivery: 'Ukupno sa dostavom',
  youHaveNotPlacedAnorderYet: 'Niste još uvijek napravili narudžbu',
  quantity: 'Količina',
  amountWithoutVat: 'Iznos bez PDV-a',
  vatAmount: 'Iznos PDV-a',
  orderNo: 'Narudžba br',
  days: 'dana',
  time: 'Vrijeme',
  quantity2: 'KOLIČINA',
  rejectOrd: 'Odbij nar',
  approveOrd: 'Odobri nar',
  wishListIsEmpty: 'Lista želja prazna',
  sale: 'AKCIJA',
  totalWithoutTax: 'Ukupno bez poreza',
  sendRequest: 'POŠALJI ZAHTJEV',
  promoCode: 'Promo kod',
  send: 'Pošalji',
  registrationCode: 'Šifra prijave',
  created: 'Kreirano',
  giftCard: 'Poklon kod',
  changePassword: 'Promjena lozinke',
  emailAddress: 'Email adresa',
  oldPassword: 'Stara lozinka',
  deleteUserAcc: 'IZBRIŠI KORISNIČKI RAČUN',
  permanentlyDeletedAcc: 'Korisnički račun će biti trajno obrisan',
  confirmNewPassword: 'Potvrdite novu lozinku',
  passwordConfirmation: 'Potvrda lozinke',
  newPassword: 'Nova lozinka',
  newPassLeaveBlank: 'Nova lozinka (ostavite prazno ukoliko ne želite mijenjati)',
  currentPassLeaveBlank: 'Trenutna lozinka (ostavite prazno ukoliko ne želite mijenjati)',
  areasOfInterest: 'Interesna područja',
  chooseAreaOfInterest: 'Izaberite interesna područja',
  totalTax: 'Ukupno poreza',
  price: 'Cijena',
  price2: 'CIJENA',
  newAddress2: 'Nova adresa',
  show: 'Prikaži',
  stock: 'Stanje',
  yourTotalDebtIs: 'Vaše ukupno zaduženje iznosi',
  isInStock: 'Ima na stanju',
  print: 'Print',
  signUpForTheNewsletter: 'Prijavite se na newsletter',
  latestInformations: 'Dobijte sve najnovije informacije o događajima, rasprodajama i ponudama.',
  subscribe: 'Pretplatite se',
  aboutEurosanGroup: 'O Eurosan grupaciji',
  responsibleBusiness: 'Odgovorno poslovanje',
  noDataToAccordingData: 'Nema podataka prema traženim parametrima',
  jobAtEurosan: 'Posao u Eurosanu',
  vpc: 'VPC',
  products: 'proizvoda',
  phoneNumber: 'Broj telefona',
  tax: 'PDV',
  defaultAddress2: 'Zadana adresa',
  totalWithVat: 'Ukupno sa PDV',
  totalWithoutVat2: 'Ukupno bez PDV',
  summary: 'Sažetak',
  warranty: 'Garancija',
  zipCode: 'Zip kôd',
  indeterminate: 'Neodređeno',
  description: 'Opis',
  forms: {
    notValid: 'Unešeni podaci nisu validni!',
    labels: {
      username: 'Korisničko ime',
      abbreviation: 'Skraćenica',
      address: 'Adresa',
      email: 'E-mail adresa',
      articleType: 'Vrsta artikla',
      availableValues: 'Dostupne vrijednosti',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      brand: 'Brend',
      catalogNumber: 'Kataloški broj',
      category: 'Kategorija',
      code: 'Šifra',
      company: 'Kompanija',
      content: 'Sadržaj',
      country: 'Država',
      countryName: 'Naziv države',
      defaultPrice: 'Zadana cijena',
      description: 'Opis',
      fax: 'Faks',
      interestsArea: 'Djelatnost',
      isVisibleOnWeb: 'Vidljivo na webu',
      mpc: 'Maloprodajna cijena',
      name: 'Naziv',
      nc: 'Nabavna cijena',
      nettoWeight: 'Neto težina',
      officeNumber: 'Broj ureda',
      phone: 'Telefon',
      password: 'Lozinka',
      confirmPassword: 'Ponovi lozinku',
      shortDescription: 'Kratak opis',
      symbol: 'Simbol',
      taxGroup: 'Porezna grupa',
      title: 'Naziv',
      town: 'Grad',
      townName: 'Naziv grada',
      unit: 'Jedinica',
      unitOfMeasure: 'Jedinica mjere',
      videoUrl: 'Video link',
      vpc: 'Veleprodajna cijena',
      firstName: 'Ime',
      lastName: 'Prezime',
    },
    errors: {
      default: 'Dogodila se pogreska prilikom validacije.',
      email: 'Polje {field} nije validan email.',
      integer: 'Polje {field} mora biti broj.',
      minLength: 'Minimalno {count} karaktera.',
      required: 'Polje {field} je obavezno.',
      sameAs: 'Polje {field} i polje {field2} se ne podudaraju.',
      url: 'Polje {field} nije validan url.',
    },
  },
  tables: {
    email: 'E-mail',
    firstLastName: 'Ime i prezime',
    id: 'ID',
    name: 'Naziv',
    phone: 'Telefon',
    town: 'Grad',
    username: 'Korisničko ime',
  },
};
